import {GET_ORDER_LIST} from './mutation-types';
export default{
  [GET_ORDER_LIST](state, playload) {
      state.originOrderList = playload.data;
  },
  setNewMsgState(state, msgNumber) {
    state.newMsgNumber = msgNumber
  },
  setVipState(state, vip) {
    state.vip = vip
  },
  setPoints(state, points) {
    state.points = points
  },
  setSoonExpiredPoints(state, soonExpiredPoints) {
    state.soonExpiredPoints = soonExpiredPoints
  },
  setUserAvatar(state, avatar) {
    state.userAvatar = avatar
  },
  setUserMobile(state, mobile) {
    state.userMobile = mobile
  },
  setUserSensitiveMobile(state, mobile) {
    state.userSensitiveMobile = mobile
  },
  setUserNickname(state, nickname) {
    state.userNickname = nickname
  },
  setCouponQuantity(state, couponQuantity) {
    state.couponQuantity = couponQuantity
  },
  setEcardQuantity(state, ecardQuantity) {
    state.ecardQuantity = ecardQuantity
  },
  setappid(state, appid) {
    state.appid = appid
  },
  setmsgVersion(state, msgVersion) {
    state.msgVersion = msgVersion
  },
  setRightsQuantity(state, rightsQuantity) {
    state.rightsQuantity = rightsQuantity
  },
  setGardenEntrance(state, gardenEntrance) {
    state.gardenEntrance = gardenEntrance
  },
  setGardenPop(state, gardenPop) {
    state.gardenPop = gardenPop
  },
  setNewUser(state, newUser) {
    state.newUser = newUser
  },
  setGardenSigned(state, gardenSigned) {
    state.gardenSigned = gardenSigned
  },
  setGardenGuideDisplay(state, gardenGuideDisplay) {
    state.gardenGuideDisplay = gardenGuideDisplay
  }
}
